"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../theme/styled-components"));
var icons_1 = tslib_1.__importDefault(require("../icons"));
var IconWrapper = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-right: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  margin-right: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"])), polished_1.rem(8));
var DefaultComment = function (_a) {
    var comment = _a.comment, sport = _a.sport;
    var renderCommentIcon = function (label, sportType) {
        if (![
            'goal',
            'yellowCard',
            'redCard',
            'redCardAfterYellow',
            'penOut',
            'penCatch',
            'change',
            'important',
        ].includes(label || '')) {
            return null;
        }
        var eventType = label || '';
        if (label === 'penOut' || label === 'penCatch') {
            eventType = 'important';
        }
        if (label === 'redCardAfterYellow') {
            eventType = 'redCard';
        }
        return (react_1["default"].createElement(IconWrapper, null,
            react_1["default"].createElement(icons_1["default"], { size: 14, eventType: eventType || '', title: label || '', sport: sportType || '' })));
    };
    return comment.message ? (react_1["default"].createElement("div", null,
        renderCommentIcon(comment.label, sport),
        react_1["default"].createElement("span", { dangerouslySetInnerHTML: { __html: comment.message } }))) : null;
};
exports["default"] = DefaultComment;
var templateObject_1;
